import React from "react";
import { Link } from "react-router-dom";
import Advisory1 from "./advisory1";

const advisoryData = [
  {
    to: "/chat?isBack=true",
    image: "/assets/AppIcons/doctor.png",
    title: "Online Doctors",
  },
  {
    to: "/monthly-mobile?isBack=true",
    image: "/assets/AppIcons/MobIns.png",
    title: "Mobile Insurance",
  },
  {
    to: "/car-insurance?isBack=true",
    image: "/assets/AppIcons/CarIns.png",
    title: "Car Insurance",
  },
  {
    to: "/vet-doctor-chat?isBack=true",
    image: "/assets/AppIcons/Pet&Vet.png",
    title: "Pet & Vet Doctors",
  },
  {
    to: "/agri-doctor-chat?isBack=true",
    image: "/assets/AppIcons/Agri.png",
    title: "Agri Experts",
  },
  {
    to: "/rsa?isBack=true",
    image: "/assets/AppIcons/RSA.png",
    title: (
      <>
        RSA <br /> Roadside Assistance
      </>
    ),
  },
];

const AdvisorySection = () => {
  return (
    <div className="mb-3">
      <div className="d-flex flex-wrap row-gap-2">
        {advisoryData.map((item, index) => (
          <div className="col-4 col-md-2" key={index}>
            <Link to={item.to} className="text-decoration-none">
              <Advisory1 image={item.image} title={item.title} />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvisorySection;
